import { DataLoader } from 'src/app/services/data-loader/data-loader';

export const createCase7 = () => {
    return new DataLoader('', async function (queryContext, cancellationToken) {
        // wait
        await new Promise((resolve) => setTimeout(resolve, 1000));
        this.emitter.emit({
            data: [
                {
                    date: new Date('2025-09-14').toISOString(),
                    split_group: '3.2.100',
                    commits_cnt: 609,
                },
                {
                    date: new Date('2025-09-14').toISOString(),
                    split_group: '3.2.101',
                    commits_cnt: 201,
                },
                {
                    date: new Date('2025-09-14').toISOString(),
                    split_group: '3.2.102',
                    commits_cnt: 22032,
                },
                {
                    date: new Date('2025-09-14').toISOString(),
                    split_group: '3.2.103',
                    commits_cnt: 266188,
                },
                {
                    date: new Date('2025-09-14').toISOString(),
                    split_group: '3.2.104',
                    commits_cnt: 1158467,
                },
                {
                    date: new Date('2025-09-14').toISOString(),
                    split_group: '3.2.105',
                    commits_cnt: 5136099,
                },
                {
                    date: new Date('2025-09-15').toISOString(),
                    split_group: '3.2.100',
                    commits_cnt: 116,
                },
                {
                    date: new Date('2025-09-15').toISOString(),
                    split_group: '3.2.101',
                    commits_cnt: 244,
                },
                {
                    date: new Date('2025-09-15').toISOString(),
                    split_group: '3.2.102',
                    commits_cnt: 6225,
                },
                {
                    date: new Date('2025-09-15').toISOString(),
                    split_group: '3.2.103',
                    commits_cnt: 225926,
                },
                {
                    date: new Date('2025-09-15').toISOString(),
                    split_group: '3.2.104',
                    commits_cnt: 747044,
                },
                {
                    date: new Date('2025-09-15').toISOString(),
                    split_group: '3.2.105',
                    commits_cnt: 5867889,
                },
                {
                    date: new Date('2025-09-15').toISOString(),
                    split_group: '3.2.200',
                    commits_cnt: 694,
                },
                {
                    date: new Date('2025-09-16').toISOString(),
                    split_group: '3.2.100',
                    commits_cnt: 15,
                },
                {
                    date: new Date('2025-09-16').toISOString(),
                    split_group: '3.2.101',
                    commits_cnt: 133,
                },
                {
                    date: new Date('2025-09-16').toISOString(),
                    split_group: '3.2.102',
                    commits_cnt: 1226,
                },
                {
                    date: new Date('2025-09-16').toISOString(),
                    split_group: '3.2.103',
                    commits_cnt: 197725,
                },
                {
                    date: new Date('2025-09-16').toISOString(),
                    split_group: '3.2.104',
                    commits_cnt: 521664,
                },
                {
                    date: new Date('2025-09-16').toISOString(),
                    split_group: '3.2.105',
                    commits_cnt: 7633144,
                },
                {
                    date: new Date('2025-09-16').toISOString(),
                    split_group: '3.2.200',
                    commits_cnt: 1488197,
                },
                {
                    date: new Date('2025-09-17').toISOString(),
                    split_group: '3.2.101',
                    commits_cnt: 104,
                },
                {
                    date: new Date('2025-09-17').toISOString(),
                    split_group: '3.2.102',
                    commits_cnt: 1295,
                },
                {
                    date: new Date('2025-09-17').toISOString(),
                    split_group: '3.2.103',
                    commits_cnt: 181703,
                },
                {
                    date: new Date('2025-09-17').toISOString(),
                    split_group: '3.2.104',
                    commits_cnt: 409981,
                },
                {
                    date: new Date('2025-09-17').toISOString(),
                    split_group: '3.2.105',
                    commits_cnt: 2936455,
                },
                {
                    date: new Date('2025-09-17').toISOString(),
                    split_group: '3.2.200',
                    commits_cnt: 7530460,
                },
                {
                    date: new Date('2025-09-18').toISOString(),
                    split_group: '3.2.100',
                    commits_cnt: 218,
                },
                {
                    date: new Date('2025-09-18').toISOString(),
                    split_group: '3.2.101',
                    commits_cnt: 72,
                },
                {
                    date: new Date('2025-09-18').toISOString(),
                    split_group: '3.2.102',
                    commits_cnt: 591,
                },
                {
                    date: new Date('2025-09-18').toISOString(),
                    split_group: '3.2.103',
                    commits_cnt: 170065,
                },
                {
                    date: new Date('2025-09-18').toISOString(),
                    split_group: '3.2.104',
                    commits_cnt: 334604,
                },
                {
                    date: new Date('2025-09-18').toISOString(),
                    split_group: '3.2.105',
                    commits_cnt: 1873427,
                },
                {
                    date: new Date('2025-09-18').toISOString(),
                    split_group: '3.2.200',
                    commits_cnt: 10028915,
                },
                {
                    date: new Date('2025-09-19').toISOString(),
                    split_group: '3.2.100',
                    commits_cnt: 76,
                },
                {
                    date: new Date('2025-09-19').toISOString(),
                    split_group: '3.2.101',
                    commits_cnt: 75,
                },
                {
                    date: new Date('2025-09-19').toISOString(),
                    split_group: '3.2.102',
                    commits_cnt: 509,
                },
                {
                    date: new Date('2025-09-19').toISOString(),
                    split_group: '3.2.103',
                    commits_cnt: 163913,
                },
                {
                    date: new Date('2025-09-19').toISOString(),
                    split_group: '3.2.104',
                    commits_cnt: 288349,
                },
                {
                    date: new Date('2025-09-19').toISOString(),
                    split_group: '3.2.105',
                    commits_cnt: 1966012,
                },
                {
                    date: new Date('2025-09-19').toISOString(),
                    split_group: '3.2.200',
                    commits_cnt: 10652647,
                },
                {
                    date: new Date('2025-09-19').toISOString(),
                    split_group: '3.2.201',
                    commits_cnt: 417142,
                },
                {
                    date: new Date('2025-09-20').toISOString(),
                    split_group: '3.2.101',
                    commits_cnt: 36,
                },
                {
                    date: new Date('2025-09-20').toISOString(),
                    split_group: '3.2.102',
                    commits_cnt: 570,
                },
                {
                    date: new Date('2025-09-20').toISOString(),
                    split_group: '3.2.103',
                    commits_cnt: 161276,
                },
                {
                    date: new Date('2025-09-20').toISOString(),
                    split_group: '3.2.104',
                    commits_cnt: 250005,
                },
                {
                    date: new Date('2025-09-20').toISOString(),
                    split_group: '3.2.105',
                    commits_cnt: 2359754,
                },
                {
                    date: new Date('2025-09-20').toISOString(),
                    split_group: '3.2.200',
                    commits_cnt: 5438022,
                },
                {
                    date: new Date('2025-09-20').toISOString(),
                    split_group: '3.2.201',
                    commits_cnt: 6332426,
                },
                {
                    date: new Date('2025-09-21').toISOString(),
                    split_group: '3.2.101',
                    commits_cnt: 45,
                },
                {
                    date: new Date('2025-09-21').toISOString(),
                    split_group: '3.2.102',
                    commits_cnt: 759,
                },
                {
                    date: new Date('2025-09-21').toISOString(),
                    split_group: '3.2.103',
                    commits_cnt: 158462,
                },
                {
                    date: new Date('2025-09-21').toISOString(),
                    split_group: '3.2.104',
                    commits_cnt: 232183,
                },
                {
                    date: new Date('2025-09-21').toISOString(),
                    split_group: '3.2.105',
                    commits_cnt: 3122229,
                },
                {
                    date: new Date('2025-09-21').toISOString(),
                    split_group: '3.2.200',
                    commits_cnt: 2562170,
                },
                {
                    date: new Date('2025-09-21').toISOString(),
                    split_group: '3.2.201',
                    commits_cnt: 10549137,
                },
            ],
            queryContext: {
                datasourceColumns: [
                    {
                        id: 'ACTIVITY_APP_VERSION',
                        state: {
                            value: {
                                options: [],
                                filterType: 'include',
                            },
                            isFilterApplied: false,
                            isSplitApplied: true,
                        },
                    },
                ],
                settings: {
                    datetimeAggregation: 'day',
                },
            },
            status: 'ok',
            statusMessage: '',
            isLoading: false,
            sqlAndJsProcessing: '',
        });
    });
};
